<template>
  <div class="sidebar">
    <v-navigation-drawer
      permanent
      style="width: 100%; background-color:#3f4956;"
    >
      <v-list>
        <template v-for="linkItem in linkItems">
          <router-link :to="linkItem.link" v-if="!linkItem.children">
            <v-list-item>
              <img :src="linkItem.imgsrc" alt="" width="20" />
              <v-list-item-title>{{ linkItem.text }}</v-list-item-title>
            </v-list-item>
          </router-link>
          <v-list-group
            v-if="linkItem.children && linkItem.children.length"
            :key="linkItem.children.text"
          >
            <template v-slot:activator>
              <img :src="linkItem.imgsrc" alt="" width="20" />
              <v-list-item-title>{{ linkItem.text }}</v-list-item-title>
            </template>
            <v-list-item-content
              v-for="item in linkItem.children"
              :key="item.text"
            >
              <router-link :to="item.link">
                <v-list-item-title v-text="item.text"></v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["linkItems"],
  mounted() {},
  methods: {}
};
</script>
